//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { blobToBase64, getBase64, humanFileSize } from "@/utils/converter"
import { isValidHttpUrl } from "@/utils/helpers";
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';
import { isFile, isBlob } from "../../utils/objects.js";
import { ASPECT_RATIO, BUILD_GENERAL_STORAGE_IMAGE_PATH, BUILD_STORAGE_PATH } from "../../constants/ui.js";
import IconView from "@/components/objects/IconView.vue";

const convertTags = (tags) => {
  return tags.map(x => {
    return { key: x.value, label: x.value }
  })
}
export default {
  name: "TheImage",
  components: {
    Cropper,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
    IconView,
  },
  props: {
    minHeight: {
      type: Number,
      required: false
    },
    minWidth: {
      type: Number,
      required: false
    },
    maxHeight: {
      type: Number,
      required: false
    },
    maxWidth: {
      type: Number,
      required: false
    },
    maxByteSize: {
      type: Number,
      default: () => {
        return 1024 * 1024 * 5 // мб
      }
    },
    mimeType: {
      type: Array,
      default: () => ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/svg+xml']
    },
    showCondition: {
      type: Boolean,
      default: true
    },
    enableCropper: {
      type: Boolean,
      default: false
    },
    simpleUi: {
      type: Boolean,
      default: false
    },
    defaultCropAspectRation: {
      type: Number,
      default: null
    },
    byLinkUpload: {
      type: Boolean,
      default: true
    },
    value: {},
    uploadTo: {
      type: Object,
      default: null
    },
    useCollection: {
      type: Boolean,
      default: true
    },
    storageName: {
      type: String,
      default: null
    },
    collectionScope: {
      type: String,
      default: 'icon'
    },
    icon: {
      type: String
    },
    allowWithoutRatio: {
      Boolean,
      default: false
    },
    forceSquareRatio: {
      type: Boolean,
      default: false
    },
    appName: {
      type: String,
      default: 'objects'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconColor: {
      type: String,
      default: "picto_black"
    },
    showMinMaxConditions: {
      type: Boolean,
      default: true
    },
    showShortCat: {
      type: Boolean,
      default: true
    },
    boxSize: {
      type: Number,
      required: false
    },
    extraAspectRatio: {
      type: Array,
      default: () => Array()
    },
    adminPermission: {
      type: Boolean,
      default: true
    },
    suitableIcons: {
      type: Array,
      required: false
    },
    suitableImages: {
      type: Array,
      required: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isWorkArea: {
      type: Boolean,
      default: false
    },
    /** Только отдать blob после кропа, без POST /admin/uploader/ */
    cropEmitOnly: {
      type: Boolean,
      default: false
    },
    generalStoreParams: {
      type: [Object, null],
      default: null
    },
    context: {
      type: Object,
      default: null
    },
  },
  emits: ["file-change", "file-clear", "input-file-url", "uploader-close"],
  data() {
    let imageLoadingInProgress = false
    let checkUrl = (rule, value, callback) => {
      if (!this.byLinkUploadFile && !value) {
        return callback(new Error('Введите ссылку или выберите файл на диске'));
      }
      if (!value) return callback()
      if (!isValidHttpUrl(value)) {
        return callback(new Error('Введите валидную ссылку'));
      }
      callback()
    };
    const tagsValidator = (rule, value, callback) => {
      if (value === undefined || value.length === 0) {
        return callback(new Error('Добавьте минимум один тег'));
      }

      if (value.length > 5) {
        return callback(new Error('Не более 5 тегов'));
      }

      return callback()
    }
    return {
      pictoByObj: null,
      visibleCropper: false,
      file: null,
      aspectRatioOptions: this.forceSquareRatio
        ? [
          {
            label: '1:1',
            value: ASPECT_RATIO["1_1"]
          },
        ]
        : [
          {
            label: '2:1',
            value: ASPECT_RATIO["2_1"]
          },
          ...this.extraAspectRatio,
          {
            label: '4:3',
            value: ASPECT_RATIO["4_3"]
          },
          {
            label: '8:7',
            value: ASPECT_RATIO["8_7"]
          },
          {
            label: '1:1',
            value: ASPECT_RATIO["1_1"]
          },
          {
            label: '7:8',
            value: ASPECT_RATIO["7_8"]
          },
          {
            label: '3:4',
            value: ASPECT_RATIO["3_4"]
          },
        ],
      stencilProps: {
        aspectRatio: null
      },
      byLinkUploadVisible: false,
      uploadFileBlob: "",
      byLinkUploadIsLoading: false,
      byLinkUploadIsReady: false,
      byLinkUploadIsFail: false,
      byLinkUploadFile: null,
      uploadByUrlForm: {
        url: '',
        tags: undefined,
        tagQ: ""
      },
      rules: {
        url: [{ validator: checkUrl, trigger: 'change' }],
      },
      needDelete: false,
      state: null,
      loadFileByUrl: null,
      similarIcons: [],
      suitable: {
        isOpen: false,
        form: {},
        open: () => {
          this.v2UploaderShow = true
        },
        close: () => {
          this.v2UploaderShow = false
        },
        reset: () => {
          this.suitable.url = ""
        },
        select: (val) => {
          this.$emit('input', val)
          this.closeChoiceCollection()
        }
      },
      collectionSelector: {
        isOpen: false,
        form: {},
        list: [],
        open: () => {
          this.v2UploaderShow = true
        },
        close: () => {
          this.v2UploaderShow = false
        },
        reset: () => {
          this.collectionSelector.url = ""
        },
        select: (val) => {
          this.$emit('input', val)
          this.closeChoiceCollection()
        }
      },
      v2UploaderShow: false,
      v2UploaderActiveTab: "",
      v2UploadInProgress: false,
      tags: [],
      latestDownloadFile: null,
      exportTagValidator: tagsValidator,
      uploadCandidate: {
        blob: null,
        width: Infinity,
        height: Infinity,
        url: "",
        aspectRatio: Infinity,
        statusFetchPreview: null,
        statusFileUploading: null
      },
      highlightUploadButton: false
    }
  },
  computed: {
    resolvedStore() {
      return this.$store || this.context.store || null
    },
    resolvedAddServerPath() {
      const fn = this.context?.addServerPath || this.$addServerPath || ((p) => p)
      return (path) => fn(path)
    },
    contextAuth() {
      return this.$auth || this.context.auth
    },
    contextAxios() {
      return this.$axios || this.context.axios
    },
    contextMessage() {
      return this.$message || this.context.message
    },
    minHeightValue() {
      if (this.collectionScope === 'background') {
        return this.minHeight ?? 200
      } else {
        return this.minHeight ?? 32
      }
    },
    minWidthValue() {
      if (this.collectionScope === 'background') {
        return this.minWidth ?? 200
      } else {
        return this.minWidth ?? 32
      }
    },
    maxHeightValue() {
      if (this.collectionScope === 'background') {
        return this.maxHeight ?? 2000
      } else {
        return this.maxHeight ?? 512
      }
    },
    maxWidthValue() {
      if (this.collectionScope === 'background') {
        return this.maxWidth ?? 2000
      } else {
        return this.maxWidth ?? 512
      }
    },
    choiceFileTooltip() {
      return `Min: ${this.minWidthValue + 'x' + this.minHeightValue + (this.maxWidthValue !== Infinity && this.maxHeightValue !== Infinity ? '; Max: ' + this.maxWidthValue + 'x' + this.maxHeightValue : '')}`
    },
    accept: function () {
      return this.mimeType.join(",")
    },
    model: {
      get() {
        const valIsString = typeof this.state === 'string'
        const valisBase64 = valIsString && this.state.startsWith('data:image')

        try {
          if (this.generalStoreParams && !valisBase64 && this.state) {
            return {
              url: BUILD_GENERAL_STORAGE_IMAGE_PATH(this.state)
            }
          }
        } catch (e) {}

        try {
          if (this.state && !valisBase64) {
            if (this.uploadTo && this.uploadTo.action && this.uploadTo.id) {
              if (this.collectionScope === 'background') {
                this.getPictoByObj()
                return {
                  url: this.resolvedAddServerPath(this.uploadTo.action.replace('{id}', this.pictoByObj))
                }
              } else {
                return {
                  url: this.resolvedAddServerPath(this.uploadTo.action.replace('{id}', this.uploadTo.id))
                }
              }
            }
          }
        } catch (e) {

        }


        if (this.state && !valisBase64) {
          const isSuitable = this.suitableImages?.find(el => el.id === this.state);
          if (isSuitable) {
            return {
              url: this.resolvedAddServerPath(`/public/object_images_files/${this.state}/`),
            }
          } else if (this.storageName) {
            return {
              url: BUILD_STORAGE_PATH(this.storageName, this.state),
            }
          } else {
            return {
              url: this.resolvedAddServerPath(`/admin/icon_files/${this.state}/${this.iconColor}/`),
            }
          }
        }
        if (this.state && valisBase64) {
          return {
            url: this.state
          }
        }
        return null
      },
      set(val) {
        if (isFile(val) || isBlob(val)) {
          blobToBase64(val).then(r => {
            this.state = r
          })
        } else {
          this.state = val
        }
      }
    },
    humanMaxSize() {
      if (!Number.isFinite(this.maxByteSize)) {
        return 'макс. размер не установлен'
      }
      return humanFileSize(this.maxByteSize, true, 0)
    },
    showAddTagBtn() {
      return this.uploadByUrlForm.tagQ.length >= 5 && !this.tags.find(x => x.key === this.uploadByUrlForm.tagQ) &&
        (this.uploadByUrlForm.tags === undefined || (Array.isArray(this.uploadByUrlForm.tags) && this.uploadByUrlForm.tags.length < 5))
    },
    collectionScopeData() {
      return {
        choiceLabel: this.collectionScope === 'background' ? 'Выбрать фон из коллекции' : '+ Иконка (из\u00A0коллекции)',
        modalLabel: this.collectionScope === 'background' ? 'Выбор фона' : 'Выбор иконки',
      }
    },
    hasRoute() {
      return this.$router;
    }
  },
  async mounted() {
    await this.loadCollectionData();
    this.state = cloneDeep(this.value)
  },
  methods: {
    contextInfo(evt) {
      return this.$info(evt) || this.context.info(evt)
    },
    contextConfirm(evt) {
      return this.$confirm(evt) || this.context.confirm(evt)
    },
    contextWarning(evt) {
      return this.$warning(evt) || this.context.warning(evt)
    },
    async loadCollectionData() {
      const store = this.resolvedStore
      if (this.collectionScope === 'background') {
        if (!this.contextAuth?.loggedIn) {
          await this.contextAxios.get(`${process.env.BASE_URL_V2}/public/backgrounds/`).then((response) => {
            const items = response?.data?.items

            if (items) {
              this.collectionSelector.list = [...items.map(({ ...x }, index) => {
                x.tags = x.tags.map(tag => tag.value)
                return x
              })]
            }
          })
        } else {
          if (!store) return
          await store.dispatch(this.isAdmin ? 'backgrounds/fetchObjects' : 'backgrounds/fetchPublicObjects').then(({ items }) => {
            this.collectionSelector.list = [...items.map(({ ...x }, index) => {
              x.tags = x.tags.map(tag => tag.value)
              return x
            })]
          })
        }
      } else {
        if (!store) return
        await store.dispatch('icons/fetchObjects').then(({ items }) => {
          this.collectionSelector.list = [...cloneDeep(items)]
        })
      }
    },
    /**
     * @param file {Blob}
     * @param url {String}
     * @return {Promise<any>}
     */
    uploadStaticFile(file, url) {
      const payload = {}
      if (!file || !(file instanceof Blob)) return Promise.reject('Некорректный файл или тип данных')
      if (file) payload.file = file
      if (url) payload.url = url
      const store = this.resolvedStore
      if (!store) return Promise.reject('Store is not available')
      return store.dispatch('uploadFile', payload)
    },
    validateFile: function (file) {
      return new Promise((resolve, reject) => {
        if (!this.mimeType.includes(file.type)) {
          return reject('Некорректный формат')
        }

        if (file.size > this.maxByteSize) {
          return reject(`Размер файла должен быть не более ${this.humanMaxSize}`)
        }

        if (file.type !== 'image/svg+xml') {
          const image = new Image();

          image.onload = (event) => {
            const blob = event.target;

            if (blob.width + blob.height === 0) {
              throw blob.onerror();
            }

            // Check the image resolution
            if (blob.width < this.minWidthValue || blob.height < this.minHeightValue) {
              return reject(`Изображение должно быть не менее ${this.minWidthValue}x${this.minHeightValue}`)
            }

            // Check the image resolution
            if (blob.width > this.maxWidthValue || blob.height > this.maxWidthValue) {
              return reject(`Изображение должно быть не более ${this.maxWidthValue}x${this.maxHeightValue}`)
            }
            return resolve({ file: file, width: blob.width, height: blob.height });
          };


          image.onerror = () => {
            return reject('Невалидный файл')
          }

          image.src = window.URL.createObjectURL(file);
        } else {
          const image = new Image();

          image.onload = (event) => {
            const blob = event.target;

            if (blob.width + blob.height === 0) {
              throw blob.onerror();
            }

            const ratio = blob.width / blob.height
            const resizeIndex = 256 / blob.width;

            blob.width = blob.width * ratio * resizeIndex
            blob.height = blob.height * ratio * resizeIndex

            return resolve({ file: file, width: blob.width, height: blob.height });
          };

          image.onerror = () => {
            return reject('Невалидный файл')
          }

          image.src = window.URL.createObjectURL(file);
        }
      })
    },
    openUploadingDialog: function () {
      this.uploadByUrlForm.url = ""
      this.uploadByUrlForm.tagQ = ""
      this.$refs.upload_field.click()
    },
    onChangeFile: function (event) {
      const file = event.target.files[0];
      if (this.uploadByUrlForm.url) {
        this.uploadByUrlForm.url = ""
        this.$message.info('Изображение было отредактировано. Связь с исходной ссылкой удалена')
      }
      this.fileProcessing(file)
    },
    fileProcessing(file) {
      if (!file) return
      this.validateFile(file)
        .then(r => {
          if (this.enableCropper) {
            if (this.forceSquareRatio) {
              this.setAspectRatio(ASPECT_RATIO["1_1"], false)
            } else if (this.defaultCropAspectRation) {
              this.setAspectRatio(this.defaultCropAspectRation, false)
            } else {
              this.setAspectRatio(this.detectAspectRatio(r.width, r.height), false)
            }

            blobToBase64(r.file)
              .then(response => {
                this.file = response;
                this.visibleCropper = true;
              })
          } else {
            this.$emit("file-change", r);
            this.$emit("input", r.file);
            this.$refs.upload_field.value = "";
          }
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    resetUploadModal() {
      this.$emit('uploader-close')
      this.closeChoiceCollection()
      this.byLinkUploadIsLoading = false
      this.byLinkUploadIsReady = false
      this.byLinkUploadIsFail = false
      this.uploadByUrlForm.url = ""
      this.uploadByUrlForm.tags = undefined
      this.uploadByUrlForm.tagQ = ""
      this.byLinkUploadFile = null
      this.collectionSelector.url = ""
      this.pictoByObj = null
      this.similarIcons = []
      this.highlightUploadButton = false
    },
    async performUploadFile() {
      this.v2UploadInProgress = true
      this.loadFileByUrl = this.uploadByUrlForm.url
      const store = this.resolvedStore
      if (!store) return Promise.reject(false)
      const uploadedFile = await store.dispatch('uploadFile', {
        file: this.byLinkUploadFile,
        url: this.uploadByUrlForm.url
      })
        .catch(error => {
          if (error.response.data.error === "INVALID_SIZE" || error.response.status === 413) {
            this.$message.error('Изображение слишком большое');
          } else if (error.response.data.error === "NotUniqueError") {
            this.$message.error('Такое изображение уже было загружено. Выберите другое или измените пропорции');
          }
        })
        .finally(() => this.v2UploadInProgress = false)

      if (!uploadedFile) return Promise.reject(false)

      if (!this.useCollection) {
        if (this.generalStoreParams) {
          if (uploadedFile.id && typeof uploadedFile.id === 'string') {
            try {
              const depotId = await store.dispatch('generalUploadImage', {
                ...this.generalStoreParams,
                uploaded_file_id: uploadedFile.id,
              });

              this.$emit('input', depotId);
            } catch (e) {}
          }
        } else {
          this.$emit('input', uploadedFile.id)
        }
        if (this.uploadByUrlForm.url) {
          this.$emit('input-file-url', this.uploadByUrlForm.url)
        }
        this.model = this.byLinkUploadFile
        this.v2UploadInProgress = false
        this.resetUploadModal()
        return Promise.resolve(uploadedFile.id)
      }
      switch (this.collectionScope) {
      case "background":
        return store.dispatch('backgrounds/createObject', {
          picto: uploadedFile.id,
          tags: this.uploadByUrlForm.tags
        })
          .then(({ id }) => {
            this.$emit('input', id)
            this.resetUploadModal()
          })
          .catch(async error => {
            if (error.response.data.detail.slug === "HASH_COLLISION") {
              await store.dispatch(this.isAdmin ? 'backgrounds/fetchObjects' : 'backgrounds/fetchPublicObjects', error.response.data.detail.id).then(r => {
                this.similarIcons = [r]
              })
            }
          })
          .finally(() => {
            this.v2UploadInProgress = false
          })
      default:
        return store.dispatch('icons/createObject', {
          picto: uploadedFile.id,
          tags: this.uploadByUrlForm.tags,
          from_app: this.appName
        })
          .then(({ id }) => {
            this.$emit('input', id)
            this.resetUploadModal()
          })
          .catch(async error => {
            if (error.response.data.detail.slug === "HASH_COLLISION") {
              await store.dispatch('icons/fetchObject', error.response.data.detail.id).then(r => {
                this.similarIcons = [r]
              })
            }
          })
          .finally(() => {
            this.v2UploadInProgress = false
          })
      }
    },
    async startProcessingForUrl(ignoreValidate = false) {
      if (ignoreValidate) return this.performUploadFile()
      this.$refs.uploadIconForm.validate(async (valid) => {
        if (valid) {
          await this.performUploadFile()
        }
      })
    },
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    detectAspectRatio(width, height) {
      const aspectRatio = width / height;

      const matchAspectRatio = (arr, number) =>
        arr.map(it => {
          return {
            base: it,
            result: Math.abs(it - number)
          };
        }).sort((a, b) => a.result - b.result)[0].base

      return matchAspectRatio(this.aspectRatioOptions.map(x => x.value), aspectRatio);
    },
    setAspectRatio(val, refresh = true) {
      if (this.$refs.cropper) this.$refs.cropper.reset();
      this.stencilProps.aspectRatio = val;
      if (refresh) this.$refs.cropper.refresh();
    },
    resetCropper() {
      this.visibleCropper = false;
      this.file = null
      this.$refs.upload_field.value = ""
      this.stencilProps = {
        aspectRatio: null
      }
    },
    async onCrop() {
      const { canvas, image, coordinates } = this.$refs.cropper.getResult();
      this.similarIcons = []
      if (!this.simpleUi || this.isWorkArea) {
        /* Прямая загрузка файлов, без иконок */
        this.v2UploadInProgress = true
        const ratio = cloneDeep(this.stencilProps.aspectRatio)
        const blob = await new Promise((resolve, reject) => {
          canvas.toBlob((canvasBlob) => resolve(canvasBlob))
        })

        if (this.cropEmitOnly) {
          this.$emit('file-change', {
            image: blob,
            coordinates,
            aspectRatio: ratio,
          })
          this.closeChoiceCollection()
          this.resetCropper()
          this.v2UploadInProgress = false
          return
        }

        const store = this.resolvedStore
        if (!store) return
        await store.dispatch('uploadFile', {
          file: canvas.toDataURL(),
          url: this.uploadByUrlForm.url
        })
          .then(r => {
            this.$emit("file-change", {
              image: blob,
              coordinates: coordinates,
              aspectRatio: ratio,
              id: r.id,
              image_url: this.uploadByUrlForm.url
            });
            this.uploadByUrlForm.url = ""
            this.closeChoiceCollection();
            this.resetCropper();
          })
          .catch(error => {
            if (error.response.data.detail.slug === "INVALID_SIZE" || error.response.status === 413) {
              this.$message.error('Изображение слишком большое');
            } else if (error.response.data.detail.slug === "NotUniqueError") {
              this.$message.error('Такое изображение уже было загружено. Выберите другое или измените пропорции');
            }
          })
          .finally(() => {
            this.v2UploadInProgress = false
          }
          )
      } else {
        /* Загрузка иконок */
        await new Promise(async (resolve, reject) => {
          canvas.toBlob(async (blob) => {
            this.byLinkUploadIsReady = true
            this.byLinkUploadIsFail = false
            this.byLinkUploadFile = blob;
            this.uploadFileBlob = URL.createObjectURL(blob);
            if (!this.useCollection) {
              await this.startProcessingForUrl(true).then(r => {
                this.closeChoiceCollection()
                this.resetCropper();
              })

              return resolve()
            }
            if (!this.v2UploaderShow) await this.openChoiceCollection('upload-self-file')
            this.$refs.uploadIconForm && this.$refs.uploadIconForm.validateField('url')
            this.resetCropper();
            resolve()
          }, image.src.includes('image/jpeg') ? 'image/jpeg' : 'image/png')
        })
      }
    },
    clearImage() {
      this.$emit('file-clear')

      if (this.value && this.value.has_data) {
        this.needDelete = true
      }

      this.$emit('input', null)
      this.$emit('update:icon', null)
      this.model = null
    },
    previewImage: async function () {
      if (this.collectionScope !== 'background') {
        let image = null;
        if (this.storageName) {
          image = this.model.url;
        } else {
          const blob = await fetch(this.model.url).then(r => r.blob());
          image = await getBase64(blob);
        }

        this.contextInfo({
          footer: null,
          title: null,
          content: function (h) {
            return (<img src={image} class="popup-img-preview"/>)
          },
          forceRender: true,
          centered: true,
          closable: true,
          width: Math.min((this.simpleUi || this.isWorkArea) ? 460 : 860, window.innerWidth - 100),
          maskClosable: true,
          class: `preview-image-modal ${this.iconColor === 'picto_white' ? 'bg' : ''}`
        })
      } else {
        if (typeof this.state === 'string' && this.state.startsWith('data:image')) {
          const blob = await fetch(this.model.url).then(r => r.blob());
          const base64img = await getBase64(blob);

          this.contextInfo({
            footer: null,
            title: null,
            content: function (h) {
              return (<img src={base64img} class="popup-img-preview"/>)
            },
            forceRender: true,
            centered: true,
            closable: true,
            width: Math.min((this.simpleUi || this.isWorkArea) ? 460 : 860, window.innerWidth - 100),
            maskClosable: true,
            class: `preview-image-modal ${this.iconColor === 'picto_white' ? 'bg' : ''}`
          })
        } else {
          this.getPictoByObj();
          const img = this.resolvedAddServerPath(this.uploadTo.action.replace('{id}', this.pictoByObj));

          this.contextInfo({
            footer: null,
            title: null,
            content: function (h) {
              return (<img src={img} class="popup-img-preview"/>)
            },
            forceRender: true,
            centered: true,
            closable: true,
            width: Math.min((this.simpleUi || this.isWorkArea) ? 460 : 860, window.innerWidth - 100),
            maskClosable: true,
            class: `preview-image-modal ${this.iconColor === 'picto_white' ? 'bg' : ''}`
          })
        }

      }

    },
    outsideClickHandler(event) {
      if (event.target.classList.contains('ant-modal-wrap')) {
        event.preventDefault()
        event.stopPropagation()

        this.contextConfirm({
          title: 'Выйти из режима загрузки изображения?',
          okText: 'Выйти',
          cancelText: 'Продолжить',
          onOk: () => {
            this.resetCropper()
            this.resetUploadModal()
          },
          onCancel() {
          }
        })
      }
    },
    handleClickToTrigger() {
      if (!this.useCollection) {
        this.openChoiceCollection('upload-self-file')
      } else {
        this.openChoiceCollection()
      }
    },
    openChoiceCollection(tab = this.suitableImages ? 'select-from-suitable-images' : this.suitableIcons ? "select-from-suitable-collection" : "select-from-collection", highlight = false) {
      this.v2UploaderActiveTab = tab
      this.v2UploaderShow = true
      if (highlight) {
        this.highlightUploadButton = true
      }
      this.$emit('open-uploader')
    },
    closeChoiceCollection() {
      this.v2UploaderShow = false
      this.v2UploaderActiveTab = ""
      this.collectionSelector.url = undefined
      this.suitable.url = undefined
    },
    collectionSelectorFetch: debounce(async function (val) {
      const store = this.resolvedStore
      switch (this.collectionScope) {
      case "background":
        if (!store) return
        store.dispatch(this.isAdmin ? 'backgrounds/fetchObjects' : 'backgrounds/fetchPublicObjects', { q: val }).then(({ items }) => {
          this.collectionSelector.list = [...items.map(({ ...x }, index) => {
            x.tags = x.tags.map(tag => tag.value)
            return x
          })]
        })
        break
      default:
        if (!store) return
        store.dispatch('icons/fetchObjects', { q: val }).then(({ items }) => {
          this.collectionSelector.list = [...items]
        })
      }
    }, 200),
    fetchTags: debounce(function (val) {
      if (val !== undefined) this.uploadByUrlForm.tagQ = val
      const store = this.resolvedStore
      switch (this.collectionScope) {
      case "background":
        if (!store) return
        store.dispatch('background_tags/fetchObjects', { q: val }).then(({ items }) => {
          this.tags = convertTags(items)
        })
        break
      default:
        if (!store) return
        store.dispatch('tags/fetchObjects', { q: val }).then(({ items }) => {
          this.tags = convertTags(items)
        })
      }

    }, 200),
    addTag(event) {
      event.preventDefault();
      const store = this.resolvedStore
      if (!store) return
      let promise

      switch (this.collectionScope) {
      case 'background':
        promise = store.dispatch('background_tags/createObject', { value: this.uploadByUrlForm.tagQ })
        break
      default:
        promise = store.dispatch('tags/createObject', { value: this.uploadByUrlForm.tagQ })
      }

      promise.then(r => {
        if (!Array.isArray(this.uploadByUrlForm.tags)) this.uploadByUrlForm.tags = []
        this.uploadByUrlForm.tags.push(r.value)
        this.uploadByUrlForm.tagQ = ""
      })
    },
    downloadImage: debounce(async function (value) {
      const store = this.resolvedStore
      if (!store) return
      return store.dispatch('downloadImage', value)
        .then((response) => {
          this.fileProcessing(response)
        })
        .catch(async (error) => {
          const resp = JSON.parse(await error.response.data.text())
          if (resp.detail === "INVALID_SIZE" || error.response.status === 413) {
            this.$message.error('Изображение слишком большое');
          } else {
            this.contextWarning({
              title: 'Не удалось загрузить',
              content: 'Просим скачать изображение на устройство и загрузить как файл'
            });
          }

          this.byLinkUploadIsReady = false
          this.byLinkUploadIsFail = true
        })
    }, 500),
    async changeUrlHandler(event) {
      const value = event.target.value
      if (!value || !isValidHttpUrl(value)) {
        return
      }
      const store = this.resolvedStore
      if (this.appName === 'collection' || this.useCollection) {
        switch (this.collectionScope) {
        case 'background':
          if (!store) return
          await store.dispatch(this.isAdmin ? 'backgrounds/fetchObjects' : 'backgrounds/fetchPublicObjects', { url: value })
            .then(r => {
              this.similarIcons = r.items
            })
        case 'icon':
          if (!store) return
          await store.dispatch('icons/fetchObjects', { url: value })
            .then(r => {
              this.similarIcons = r.items
            })
        }
      }

      if (!this.similarIcons.length) {
        await this.downloadImage(value)
      }
    },
    async forceUplaod() {
      await this.downloadImage()
    },
    async getPictoByObj() {
      const store = this.resolvedStore
      if (!store) return
      await store.dispatch('backgrounds/fetchPublicObject', this.uploadTo.id).then((item) => {
        this.pictoByObj = item.picto
      })
    }
  },
  watch: {
    collectionScope: {
      handler: async function(newScope, oldScope) {
        if (newScope !== oldScope && this.useCollection) {
          await this.loadCollectionData();
        }
      },
      immediate: false
    },
    visibleCropper: function (visible) {
      if (visible) {
        this.$nextTick(() => {
          document.querySelector('.ant-modal-wrap').addEventListener('click', this.outsideClickHandler)
        })
      } else {
        document.querySelector('.ant-modal-wrap').addEventListener('click', this.outsideClickHandler)
      }
    },
    value: function (val) {
      this.model = val
    }
  }
}
